var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-flame-wrapper" }, [
    _vm.isClient
      ? _c("div", [
          _c(
            "video",
            {
              staticClass: "mobile-flame-video",
              attrs: {
                preload: "auto",
                poster: "/images/placeholder_video.webp",
                autoplay: "",
                muted: "",
                loop: "",
                playsinline: "",
                src: _vm.presentation
              },
              domProps: { muted: true }
            },
            [
              _vm._v(
                "\n      Your browser does not support the video tag.\n    "
              )
            ]
          )
        ])
      : _c("div", { staticClass: "mobile-flame-skeleton" })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4611fe78", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4611fe78","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/materials/MobileFlameDisplay.vue
// module id = 1560
// module chunks = 0